"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _hubspotUrlinator = _interopRequireDefault(require("hubspot.urlinator.Url"));

var _default = {
  /**
   * Removes http(s):// and everything after the hostname.
   *
   * E.g.
   *
   *    http://example.com
   *    https://example.com
   *    http://example.com/test
   *    http://example.com/test/page
   *    example.com
   *
   *  become:
   *
   *    example.com
   *
   */
  parseWebsiteUrl: function parseWebsiteUrl(websiteAddress) {
    return new _hubspotUrlinator.default(websiteAddress).hostname.trim();
  }
};
exports.default = _default;
module.exports = exports.default;


//////////////////
// WEBPACK FOOTER
// ./js/util/InputUtil.js
// module id = 89
// module chunks = 0